import React, { forwardRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Box from 'ui-box';
import { Button, defaultFills, Icon, majorScale } from '.';
import { Card } from './Card';
import { useCombinedRefs } from './useCombineRefs';

export interface IFileInputProps {
  placeholder?: string;
  thumbnail?: string | null;
  name?: string;
  accept?: string;
  onSelectFile?: (file: File) => void;
}

export const FileInput = forwardRef<HTMLInputElement, IFileInputProps>(
  ({ placeholder, thumbnail, name, onSelectFile, accept = 'image/*' }, ref) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const combinedRef = useCombinedRefs<HTMLInputElement>(inputRef, ref);

    const [dataUrl, setDataUrl] = useState<string>();
    const loadImage = (file: File) => {
      const reader = new FileReader();
      reader.onload = () => {
        setDataUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    };

    const file =
      inputRef.current &&
      inputRef.current.files &&
      inputRef.current.files.length &&
      inputRef.current.files[0];

    return (
      <Box display="flex" alignItems="center">
        <input
          ref={combinedRef}
          name={name}
          style={{ display: 'none' }}
          type="file"
          accept={accept}
          onChange={(e) => {
            if (
              e.target.files &&
              e.target.files.length > 0 &&
              (accept.indexOf('image/') > -1 || accept.indexOf('pdf') > -1)
            ) {
              loadImage(e.target.files[0]);
              onSelectFile && onSelectFile(e.target.files[0]);
            }
          }}
        />
        <Card
          width={majorScale(6)}
          height={majorScale(6)}
          backgroundColor="white"
          marginRight={majorScale(1)}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {dataUrl || thumbnail ? (
            <Box
              is="img"
              src={dataUrl || thumbnail!}
              width="100%"
              height="100%"
              style={{ objectFit: 'contain' }}
            />
          ) : (
            <Icon icon="media" color={defaultFills.muted} />
          )}
        </Card>
        <Button
          iconLeft="add"
          minimal
          onClick={() => inputRef.current && inputRef.current.click()}
        >
          {file ? (
            file.name
          ) : placeholder ? (
            placeholder
          ) : (
            <FormattedMessage defaultMessage="Upload file" />
          )}
        </Button>
      </Box>
    );
  }
);
